<template>
    <!--Reset Verification Modal-->
    <v-dialog v-model="dialogOpen" persistent max-width="600px">
        <v-card>
            <v-card-title>
                <span class="headline">Reset User Verification</span>
            </v-card-title>
            <template v-if="submitting">
                <v-progress-linear
                        indeterminate
                        class="mb-0"
                ></v-progress-linear>
            </template>
            <template v-else>
                <v-card-text>
                    <p>Are you sure you want to reset {{userEmail}}'s verification status?</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="dialogOpen = false">Cancel</v-btn>
                    <v-btn color="error" flat @click="submit()">Reset</v-btn>
                </v-card-actions>
            </template>
        </v-card>
    </v-dialog>
</template>

<script>
  import {DialogApiRequestMixin} from '@/views/app/company/crud/crud-mixins'

  export default {
    name: 'ResetUserVerification',
    mixins: [DialogApiRequestMixin],
    props: {
      userModel: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      apiMethod: 'DELETE',
      formName: 'RESET_USER_VERIFICATION',
      successMessage: 'Successfully reset user verification!',
      failureMessage: 'Failed to reset user verification!'
    }),
    computed: {
      apiPath () {
        return `/admin/user/${this.userModel.uid}/reset_verification`
      },
      userEmail () {
        if (!this.userModel || !this.userModel.hasOwnProperty('profile')) return 'this user'

        return this.userModel.profile.email
      }
    }
  }
</script>

<style scoped>

</style>
